var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTranslate = function SvgIconTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 2a1 1 0 0 1 1 1v1.25h5a1 1 0 1 1 0 2H12.2a10 10 0 0 1-2.45 5.614q.09.06.179.118a8 8 0 0 0 3.715 1.245l1.962-3.924a1 1 0 0 1 1.788 0l3.741 7.482.02.037 1.49 2.98a1 1 0 1 1-1.79.895l-1.223-2.447h-6.264l-1.224 2.447a1 1 0 1 1-1.788-.894l1.49-2.98.019-.038.828-1.657A10 10 0 0 1 8.25 13.25a10 10 0 0 1-6 2 1 1 0 1 1 0-2 8 8 0 0 0 4.5-1.385 10 10 0 0 1-1.593-2.448 1 1 0 0 1 1.817-.834c.329.715.76 1.375 1.275 1.96a8 8 0 0 0 1.938-4.293H2.25a1 1 0 0 1 0-2h5V3a1 1 0 0 1 1-1m6.885 12.715-.767 1.535h4.264L16.5 11.986l-1.346 2.692z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTranslate;